import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface FacetListLabelWrapperProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    children: JSX.Element
}

const FacetListLabelWrapper = memo(({templating, children}: FacetListLabelWrapperProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <ComponentName>{children}</ComponentName>
        </Suspense>
    )
})
FacetListLabelWrapper.displayName = "FacetListLabelWrapper"

export default connect(FacetListLabelWrapper)
